export const NOPE_MESSAGES: readonly string[] = [
  "Are you sure you want to pass?",
  "Like... really sure?",
  "Okay but what if I'm actually hilarious?",
  "This is your last chance to not make a huge mistake.",
  "Please don't do this to me. Or to you.",
  "I already told my friends about you.",
  "My mom asked if you were coming to dinner.",
  "I bought TWO toothbrushes. TWO.",
  "I already updated my playlist called 'Us'.",
  "I'm writing your name in my notebook with hearts.",
  "If you swipe left again, a tiny violin plays somewhere.",
  "I'm begging you. For all of us.",
  "At this point, the app is emotionally invested.",
  "Fine. But we're all going to remember this.",
  "I ran out of messages and I don't really know where to go from here. One more pass and it should left swipe.",
  "lmaooo, got 'em",
  "Okay, now this is the last one. I promise."
];
